/* eslint-disable */
import { api, apiBase } from '../helpers/ApiHelper';
import { getEnvironment } from '../helpers/EnvironmentHelper';
import ErrorMessage from '../model/services/ErrorMessage';
import PagedResult from '../model/utility/PagedResult';
import GetLogsRequest from '../model/webhooks/GetLogsRequest';
import GetSettingsRequest from '../model/webhooks/GetSettingsRequest';
import ReEnableWebhooksRequest from '../model/webhooks/ReEnableWebhooksRequest';
import UpdateSettingsRequest from '../model/webhooks/UpdateSettingsRequest';
import WebhooksLogEntry from '../model/webhooks/WebhooksLogEntry';
import WebhooksUserSettings from '../model/webhooks/WebhooksUserSetttings';

const undefinedResponse = () => {
    let errorMessage: ErrorMessage = { errorMessage: 'Undefined response' };
    return errorMessage;
};

const getLogs = async (appId: string, { isTestEnvironment, ...rest }: GetLogsRequest) => {
    let url = `Apps/${appId}/Webhooks/Logs`;
    let params = {
        environment: getEnvironment(isTestEnvironment),
        ...rest,
    };
    return await api.get<PagedResult<WebhooksLogEntry>, string>(url, params).then((response) => {
        if (response.data !== undefined) {
            if (response.ok) {
                return response.data;
            } else {
                let errorMessage: ErrorMessage = { errorMessage: response.data };
                throw errorMessage;
            }
        } else {
            throw undefinedResponse();
        }
    });
};

const getNextLogs = async (nextPageUrl: string) => {
    return await apiBase.get<PagedResult<WebhooksLogEntry>, string>(nextPageUrl).then((response) => {
        if (response.data !== undefined) {
            if (response.ok) {
                return response.data;
            } else {
                let errorMessage: ErrorMessage = { errorMessage: response.data };
                return errorMessage;
            }
        } else {
            return undefinedResponse();
        }
    });
};

const getSettings = (appId: string, { isTestEnvironment }: GetSettingsRequest) => {
    let url = `Apps/${appId}/Webhooks/Settings`;
    let params = {
        environment: getEnvironment(isTestEnvironment),
    };
    return api.get<WebhooksUserSettings, string>(url, params).then((response) => {
        if (response.data !== undefined) {
            if (response.ok) {
                return response.data;
            } else {
                let errorMessage: ErrorMessage = { errorMessage: response.data };
                return errorMessage;
            }
        } else {
            throw undefinedResponse();
        }
    });
};

const updateSettings = (appId: string, { isTestEnvironment, settings }: UpdateSettingsRequest) => {
    let url = `Apps/${appId}/Webhooks/Settings`;
    let params = {
        environment: getEnvironment(isTestEnvironment),
        appId,
        settings: settings,
    };

    return api.post<undefined, string>(url, params).then((response) => {
        if (response.data === undefined && response.ok) {
            return true;
        } else if (response.data !== undefined && !response.ok) {
            let errorMessage: ErrorMessage = { errorMessage: response.data };
            return errorMessage;
        } else {
            return undefinedResponse();
        }
    });
};

const reEnableWebhooks = async (appId: string, { isTestEnvironment }: ReEnableWebhooksRequest) => {
    let url = `Apps/${appId}/Webhooks/ReEnable`;
    let params = {
        environment: getEnvironment(isTestEnvironment),
        appId,
    };

    return api.post<undefined, string>(url, params).then((response) => {
        if (response.ok) {
            return true;
        } else if (response.data !== undefined && !response.ok) {
            let errorMessage: ErrorMessage = { errorMessage: response.data };
            return errorMessage;
        } else {
            return undefinedResponse();
        }
    });
};

export default {
    getLogs,
    getNextLogs,
    getSettings,
    reEnableWebhooks,
    updateSettings,
};
